<div class="signature-options">
  <!-- Signature Checkbox -->
  <mat-checkbox 
    *ngIf="canShowCheckbox"
    [(ngModel)]="includeSignature"
    [disabled]="disabled"
    class="checkbox"
    (ngModelChange)="onIncludeSignatureChange($event)"
    (click)="$event.stopPropagation()">
    {{ label }}
  </mat-checkbox>

  <!-- Doctor Selection Dropdown -->
  <mat-form-field 
    *ngIf="canShowDoctorSelection"
    appearance="outline" 
    class="full-width"
    (keydown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()">
    <mat-label>Select Doctor's Signature</mat-label>
    <mat-select 
      [(ngModel)]="selectedDoctor"
      [disabled]="disabled"
      (selectionChange)="onSelectedDoctorChange($event.value)">
      <mat-option *ngFor="let doctor of signatureContext.groupUsers" [value]="doctor">
        {{doctor.title}} {{ doctor.name }} {{doctor.surname}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div> 